<template>
  <div class="framed">
    <table class="table is-striped is-narrow is-hoverable is-fullwidth">
      <tr v-for="file in files" :key="file.created_at">
        <td>
          {{ $t(file.author) }}
        </td>
        <td>
          <a target="_blank" :href="file.url">{{ $t(file.name) }}</a>
        </td>
        <td>
          {{ file.created_at | formatTimestamp }}
        </td>
        <td>
          <button
            @click="deleteFile(file)"
            class="button is-danger"
            type="button"
          >
            <b-icon icon="trash-can" custom-size="default" />
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/**Esto */

export default {
  name: 'RequestFiles',
  props: {
    files: {
      type: Array,
      required: true
    }
  },

  // Esto

  computed: {},
  methods: {
    deleteFile(file) {
      this.$emit('deleteFile', file)
      console.log(file)
    }
  }
}
</script>
